import { CustomList } from "components/index";
import { EmployeeCell } from "components/cell/employee/cell";
import PerformanceStatusCell from "@/modules/performance/components/cells/status";
import React from "react";
import { RenderProfile } from "components/render-profile";
import { useParams } from "react-router-dom";
import { StatusCell } from "@/components/status/cell";

const TeamPerformance = () => {
  const { quadId } = useParams();
  const columns = [
    {
      header: "Employee",
      accessorKey: "employee",
      cell: ({ getValue }) => <RenderProfile user={getValue()} />,
    },
    {
      accessorKey: "employee.reports_to",
      header: "Reports To",
      cell: EmployeeCell,
    },
    {
      accessorKey: "selfEvaluationStatus",
      header: "Self Evaluation Status",
      // cell: PerformanceStatusCell,
      cell: StatusCell,
    },
    {
      header: "Reviews",
      accessorKey: "totalReviewed",
      cell: ({ row }) => {
        const { totalReviewed, totalReviewee } = row.original;
        return (
          <span>
            {totalReviewed}/{totalReviewee}
          </span>
        );
      },
    },
    {
      header: "Average Score",
      accessorKey: "averageScore",
      cell: ({ getValue }) => (getValue() ? getValue().toFixed(2) : "--"),
    },
  ];

  const filters = {
    quadrimesterId: quadId,
  };

  return (
    <div key={quadId} className="flex-1">
      <CustomList
        endPoint="custom-ui/get-team-performance"
        title="Team Performance"
        columns={columns}
        href={(item) => item.employee?.id}
        filters={filters}
        storageKey={quadId}
        // hidePagination={true}
      />
    </div>
  );
};

export default TeamPerformance;
